import styled from 'react-emotion'
import { Checkbox } from 'shared/ui'

export default styled(Checkbox)`
  label {
    width: 85% !important;
  }
`
